export default "__VITE_ASSET__fnNHmbfH__"